export default function platformSlider() {

	if ($(".platform_slider__js").length > 0) {

		$('.platform_slider__js').slick({
			infinite: false,
			slidesToShow: 4,
			slidesToScroll: 4,
			arrows: true,
			dots: false,
			appendDots: $('.platform__js'),
			responsive: [
				{
					breakpoint: 1200,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 2,
					}
				},
				{
					breakpoint: 767,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 2,
						arrows: false,
						dots: true,
					}
				}
			]
		});
	};
};